<template>
    <main class="CuponesParaTi-MAIN DISPLAY">
    <main class="INNER-MARGIN">

        <h3>Cupones para ti</h3>
        <p>Conoce las ofertas basadas en tus intereses</p>

        <div class="CuponesParaTi-banner">
            <img :src="detail.url_imagen" class="CuponesParaTi-banner-cover" @error="(e) => { e.target.onerror = null; e.target.src = 'https://promo-colaboradores.ideeo.mx/cupones/detalle/IP%20NULL.png'; }"/>
            <img :src="detail.url_logo" class="CuponesParaTi-logo" @error="(e) => { e.target.onerror = null; e.target.src = 'https://promo-colaboradores.ideeo.mx/cupones/logos/LOGO%20NULL.png'; }"/>
        </div>

        <!--
        <img :src="detail.url_imagen" style="width: 100px; border: 1px solid gray;"/>
        <img :src="detail.url_logo" style="width: 100px; border: 1px solid gray;"/>
        <img :src="detail.url_banner" style="width: 100px; border: 1px solid gray;"/>
        <br/>{{ detail.url_imagen?.replace("https://promo-colaboradores.ideeo.mx/cupones", "") }}
        <br/>{{ detail.url_logo?.replace("https://promo-colaboradores.ideeo.mx/cupones", "") }}
        <br/>{{ detail.url_banner?.replace("https://promo-colaboradores.ideeo.mx/cupones", "") }}
        <br/><b>{{ detail.nombre }}</b>
        <br/>cupon_id: {{ detail.cupon_id }}
        -->

        <div class="CuponesParaTi-panels">
            <article>
                <div class="puedes-usar-cupon">
                    <p>{{ detail.descuento }}</p>
                    <p v-html="'<br/>'+detail.observacion_descuento"></p>
                    <p>Puedes usar este cupón:</p>
                    <div>
                        <img src="../assets/btn-en-tienda.png" v-if="detail.uso?.toLowerCase().includes('tienda')"/>
                        <img src="../assets/btn-en-linea.png" v-if="detail.uso?.toLowerCase().includes('línea')"/>
                        <img src="../assets/btn-en-telefono.png" v-if="detail.uso?.toLowerCase().includes('telefono')"/>
                        <img src="../assets/btn-whatsapp.png" v-if="detail.uso?.toLowerCase().includes('whatsapp')"/>
                        <img src="../assets/btn-en-correo.png" v-if="detail.uso?.toLowerCase().includes('correo')"/>
                    </div>
                    <img src="../assets/quiero-este-cupon.png" @click="quieroEsteCupon()" v-if="!cuponAlreadyDownloaded"><!--Guardar en favoritos al darle a "quiero este cupon"-->
                    <img :src="require(`../assets/favorite${ favorited ? '-ok' : '' }.png`)" class="favorite-icon" @click="addFavorite()">
                </div>
                <div class="cupon-info">
                    <h2 v-if="detail.instrucciones">Instrucciones de uso</h2>
                    <p v-html="detail.instrucciones"></p>
                    <h2 v-if="detail.sobre_la_marca">Sobre {{ detail.marca_grupo }}</h2>
                    <p v-if="detail.sobre_la_marca" v-html="detail.sobre_la_marca"></p>
                    <h2 v-if="detail.terminos_y_condiciones">Términos y condiciones</h2>
                    <p v-if="detail.terminos_y_condiciones" v-html="detail.terminos_y_condiciones"></p>
                    <h2>Información adicional</h2>
                </div>
                <div class="info-adicional">
                    <a v-if="detail.facebook" :href="detail.facebook" target="_blank"><img src="../assets/facebook.png"/></a>
                    <a v-if="detail.instagram" :href="detail.instagram.includes('http') ? detail.instagram : 'https://www.instagram.com/'+detail.instagram.replace('@', '')" target="_blank"><img src="../assets/instagram.png"/></a>
                    <div v-html="linkify(detail?.telefono_liga_correo)" v-if="detail?.telefono_liga_correo?.toLowerCase() != 'na' && detail?.telefono_liga_correo?.toLowerCase() != 'n/a'"></div>
                </div>
                <!--<img class="ver-ubicacion" src="../assets/btn-ubicaciones.png"/>-->

                <ViewMap :searchTerm="detail.nombre" :apiKey="'AIzaSyBWYjaZoteGTAD_Ujgi1BK1T9A3DmXqGk4'" v-if="!loading && (test || TEST)"/><!--v-if="detail.nombre && (test || TEST)"-->
            </article>

            <aside>
                <div class="evalua-este-cupon" v-if="showQualifyPanel">
                    <p>Evalúa este cupón</p>
                    <div>
                        <img src="../assets/eval-esperaba-mas.png" @click="qualify('Esperaba más')">
                        <img src="../assets/eval-estuvo-bien.png" @click="qualify('Estuvo bien')">
                        <img src="../assets/eval-me-encanto.png" @click="qualify('Me encantó')">
                    </div>
                </div>
                <div class="retro-evalua" v-if="retroActive">
                    ¡Gracias por calificar!
                </div>
                <img src="../assets/complementa-experiencia.png">
                <a v-for="(item, index) in complementaExperiencia" :key="index" :href="item?.url || getFrontURL()+'/cupon/?cupon='+item.id" target="_blank">
                    <img :src="item.imagen">
                </a>
            </aside>
        </div>

        <br><br>

        <QuieroEsteCupon v-if="quieroEsteCuponActive" :detail="detail"/>

    </main>
    </main>
</template>

<script>
import QuieroEsteCupon from './QuieroEsteCupon.vue';
import ViewMap from './ViewMap.vue';

export default {
    name: 'CuponesParaTi',
    components: {
        QuieroEsteCupon, ViewMap
    },
    data(){
        return{
            cuponId: 0,
            complementaExperiencia: [],
            detail: {},
            favorited: false,
            quieroEsteCuponActive: false, // false
            showQualifyPanel: true,
            cuponAlreadyDownloaded: false,
            retroActive: false, // false
            test: false, // delete on prod
            TEST: localStorage.getItem("m_usuario") == "XMZ9238" || localStorage.getItem("m_usuario") == "XMF1024",
            loading: true,
        }
    },
    methods: {
        getURLparams(param_){
			const params = new URLSearchParams(window.location.search);
			const result = params.get(param_) || false;
			return result;
		},
        
        getFrontURL(){
			return window.location.origin;
		},

        async getDetalle(id_){
            try {
                const response = await fetch("https://promo-colaboradores.ideeo.mx/api/detalle", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        id: parseInt(id_)
                    })
                });

                const result = await response.json();

                if(result.msg == "No hay datos"){
                    alert("El cupón solicitado no existe.");
                    window.history.back();
                    return;
                }

                this.detail = result.data[0];
                this.checkIfQualified();
            } catch (error) {
                console.error("Error en la solicitud:", error);
            } finally {
                this.loading = false;
            }
        },

        async getFavorite(id_){
            try {
                const response = await fetch("https://promo-colaboradores.ideeo.mx/api/favorito", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        usuario_id: JSON.parse(localStorage.getItem("userData")).usuario_id,
                        cupon_id: id_
                    })
                });

                const result = await response.json();
                if(result.error == 0){
                    this.favorited = result.msg == "Se encuentra en tus favoritos." ? true : false;
                }
            } catch (error) {
                console.error("Error en la solicitud:", error);
            }
        },

        getMap() {
            navigator.geolocation.getCurrentPosition((position) => {
                const coords = `${position.coords.latitude},${position.coords.longitude}`;
                const result = `https://www.google.com/maps/search/${this.detail.nombre}/@${coords}`;
                window.open(result, '_blank').focus();
            }, (error) => {
                console.error("Error obteniendo geolocalización:", error);
            });
        },

        async quieroEsteCupon(){
            this.quieroEsteCuponActive = true;
            /*try {
                const response = await fetch("https://promo-colaboradores.ideeo.mx/api/favoritos", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        usuario_id: JSON.parse(localStorage.getItem("userData")).usuario_id,
                        cupon_id: this.cuponId
                    })
                });

                const result = await response.json();
                console.log("quiero este cupon:", result)
            } catch (error) {
                console.error("Error en la solicitud:", error);
            }*/
        },

        async getComplementaTuExperiencia(){
            try {
                const response = await fetch("https://promo-colaboradores.ideeo.mx/api/cupones-recomendacion", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        usuario_id: 1,
                        tipo_cupon: 1
                    })
                });

                const result = await response.json();

                this.complementaExperiencia = result.data;
                console.log("cupones-recomendacion:", result.data)
            } catch (error) {
                console.error("Error en la solicitud:", error);
            }
        },

        async qualify(calification_){
            const response = await fetch('https://promo-colaboradores.ideeo.mx/api/nps', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    usuario_id: JSON.parse(localStorage.getItem("userData")).usuario_id,
                    cupon_id: this.detail.cupon_id,
                    calificacion: calification_,
                })
            });
            const result = await response.json();
            console.log("Calificar", result);
            if(result.msg == "Encuesta almacenada"){
                this.checkIfQualified();
                // Aqui la retro
                this.retroActive = true;
            }
        },

        async checkIfQualified(){
            const response = await fetch('https://promo-colaboradores.ideeo.mx/api/bnps', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    usuario_id: JSON.parse(localStorage.getItem("userData")).usuario_id,
                    cupon_id: this.detail.cupon_id,
                })
            });
            const result = await response.json();
            console.log("Revisar si está calificado", result)
            if(result.msg == "Se encuentra en tus nps."){
                this.showQualifyPanel = false;
            }
        },

        async checkIfAlreadyDownloaded(){
            const response = await fetch('https://promo-colaboradores.ideeo.mx/api/mis-descargas', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    usuario_id: JSON.parse(localStorage.getItem("userData")).usuario_id,
                })
            });
            const result = await response.json();

            console.log("Mis descargas", result)
            
            if(result.msg == "Estas son tus descargas."){
                for(let i of result.data){
                    if(i.cupon_id == parseInt(this.cuponId)){
                        this.cuponAlreadyDownloaded = true;
                        break;
                    }
                }
            }
        },

        async addFavorite(){
            try {
                const response = await fetch("https://promo-colaboradores.ideeo.mx/api/favoritos", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        usuario_id: JSON.parse(localStorage.getItem("userData")).usuario_id,
                        cupon_id: this.cuponId
                    })
                });

                const result = await response.json();
                if(result.error == 0){
                    if(result.msg == "Favorito guardado"){
                        this.favorited = true;
                    }else
                    if(result.msg == "Favorito eliminado"){
                        this.favorited = false;
                    }
                }
            } catch (error) {
                console.error("Error en la solicitud:", error);
            }
        },

        linkify(text) {
            if (!text) return "";
            const urlRegex = /(https?:\/\/[^\s]+)/g;
            return text.replace(urlRegex, url =>
                `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`
            );
        },

        async registrarVisitaCupon(cuponId, categoryId = null, m = null) {
            const id = Number(cuponId);
            if (!id || Number.isNaN(id)) return;

            try {
                await fetch(`https://promo-colaboradores.ideeo.mx/api/visitas-cupon`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        cupon_id: id,
                        categoria_id: categoryId ? Number(categoryId) : null,
                        m,
                    }),
                });
            } catch (error) {
                console.error("Error registrando visita de cupón:", error);
            }
        }

    },
    mounted(){
        this.cuponId = this.getURLparams("cupon");
        this.getDetalle(this.cuponId)
        .catch(error => {
            console.error(error);
            setTimeout(() => {
                this.getDetalle(this.cuponId)
            }, 5_000);
        });

        this.getFavorite(this.cuponId)
        .catch(error => {
            console.error(error);
            setTimeout(() => {
                this.getFavorite(this.cuponId)
            }, 5_000);
        });

        this.getComplementaTuExperiencia()
        .catch(error => {
            console.error(error);
            setTimeout(() => {
                this.getComplementaTuExperiencia()
            }, 5_000);
        });

        setTimeout(() => {
            this.checkIfAlreadyDownloaded();
        }, 100);

        const categoryId = this.getURLparams("categoria");
        const M = localStorage.getItem("m_usuario");
        this.registrarVisitaCupon(this.cuponId, categoryId, M);

        //TEST
        let params = new URLSearchParams(document.location.search);
        let test = params.get("test");
        if(test && test == "true") this.test = true;
    }
}
</script>

<style scoped>
.CuponesParaTi-MAIN{
    background-color: #f3fbff;
    font-family: 'Benton Sans BBVA book';
    color: #0D2F6E;
}

h3, .INNER-MARGIN > p{
    width: 100%;
    text-align: center;
}

h3{
    font-weight: 200;
    color: white;
    background-color: #051283;
    width: fit-content;
    margin-left: auto;
    margin-right: auto;
    padding: 0 1ch;
}

.INNER-MARGIN > p{
    margin-top: -1.5ch;
}

.CuponesParaTi-banner{
    width: fit-content;
    height: fit-content;
    position: relative;
}

.CuponesParaTi-banner > .CuponesParaTi-banner-cover{
    width: 100%;
    height: fit-content !important;
    max-height: 50vw !important;
    aspect-ratio: 957/421 !important;
}

.CuponesParaTi-banner .CuponesParaTi-logo{
    position: absolute;
    width: 109px;
    aspect-ratio: 1/1;
    bottom: 4vw;
    left: 4vw;
}

/* panels */
.CuponesParaTi-panels{
    display: flex;
    justify-content: space-between;
    margin-top: 2ch;
}

article{
    width: calc(65% - 1ch);
    background-color: white;
}

article >>> a{
    word-break: normal;
}

aside{
    width: 35%;
}

article, aside{
    display: flex;
    flex-direction: column;
    align-items: center;
}

/* article */
.puedes-usar-cupon{
    width: calc(100% - 2ch);
    position: relative;
    display: flex;
    flex-direction: column;
}

.puedes-usar-cupon > p:nth-child(1){
    font-family: 'Benton Sans BBVA bold';
    font-style: italic;
    margin-top: 0.75ch;
    margin-bottom: 0;
    color: black;
    font-size: 3.25ch;
}

.puedes-usar-cupon > p:nth-child(2){
    margin-top: 0;
    margin-bottom: 0;
    color: black;
    font-size: 1.4ch;
}

.puedes-usar-cupon > p:nth-child(3){
    color: gray;
    font-size: 1.4ch;
}

.puedes-usar-cupon > div{
    display: flex;
    align-items: center;
}

.puedes-usar-cupon > div img{
    height: 2.5ch;
    margin-right: 1ch;
}

.puedes-usar-cupon > img:not(.favorite-icon){
    height: 3ch;
    width: 11ch;
    margin-top: 1ch;
}

.puedes-usar-cupon > img:not(.favorite-icon):hover{
    cursor: pointer;
    filter: brightness(1.1);
}

.favorite-icon{
    position: absolute;
    width: 3ch;
    top: 1ch;
    right: 0;
    left: unset;
    cursor: pointer;
}

.cupon-info{
    color: #061283;
    width: calc(100% - 2ch);
    font-family: 'Benton Sans BBVA book';
}

.cupon-info h2{
    font-family: 'Benton Sans BBVA bold';
    margin-bottom: 0.25ch;
}

.cupon-info p{
    margin-top: 0;
}

.cupon-info a{
    word-break: normal;
}

.info-adicional{
    width: calc(100% - 2ch);
    margin: 1ch 0;
}

.info-adicional img{
    width: 4ch;
    margin-right: 2ch;
    cursor: pointer;
}

.ver-ubicacion{
    align-self: flex-start;
    margin-left: 1ch;
    height: 3ch;
    margin-bottom: 2ch;
}

/* aside */
aside img{
    max-width: calc(100% - 2ch);
}

aside > img:first-child{
    max-width: 400px;
    width: 85%;
}

aside > a{
    margin-bottom: 0.5ch;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    transition: ease all 0.5s;
}

aside > a img{
    width: calc(100% - 1ch);
    border-radius: 10px;
}

aside > a:hover{
    margin-bottom: 25px;
}

.evalua-este-cupon{
    background-color: white;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    padding-bottom: 2ch;
    margin-bottom: 1.5ch;
    border-radius: 1ch;
}

.evalua-este-cupon > div{
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    width: 100%;
}

.evalua-este-cupon > div img{
    width: 5ch;
}

.evalua-este-cupon > div img:nth-child(1){
    scale: 1.18;
}

.evalua-este-cupon > div img:hover{
    cursor: pointer;
    filter: brightness(1.1);
}

.retro-evalua{
    width: 100%;
    margin-bottom: 1ch;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: 'Benton Sans BBVA bold';
    padding: 2ch 0;
    background-color: white;
    border-radius: 1ch;
}

/* RESPONSIVE */
@media all and (max-width:780px){

    .CuponesParaTi-panels{
        flex-direction: column;
    }

    article, aside{
        width: 100%;
    }

}
</style>